module.exports = __webpack_public_path__ + "img/agro.1f9a321e.svg";